<template>
  <div class="officepage">
    <div class="searchbox">
      <div class="search">
        <img src="../../assets/images/search.png" alt class="searchpic" />
        <!-- <form action="" @submit="addfun"> -->

        <inputs
          type="search"
          placeholder="搜索科室"
          class="searchinput"
          v-model="keyword"
          v-focus
          @keyup.enter="selectDpt"
        />
      </div>
      <div>
        <span class="searchbtn" @click="selectDpt">搜索</span>
      </div>
    </div>

    <div>
      <div class="chooseCon" @click="gotoPage(item)" v-for="(item,index) in deptList" :key="index">
        <p class="condeteil">
          <span>{{item.Name}}</span>
          <img src="../../assets/images/jt.png" alt class="jtpic" />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { GetDpetAll } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "section-office",
  data() {
    return {
      deptList: [],
      keyword: this.$route.params.keyword
    };
  },
  created: function() {
    var loading = weui.loading("loading", {
      className: "custom-classname",
      content: "加载中"
    });
    GetDpetAll(this.keyword).then(response => {
      loading.hide();
      this.deptList = response.data;
    });
  },
  methods: {
    gotoPage(item) {
      this.$router.push({ path: "/officename", query: { guid: item.GUID } });
    },
    selectDpt() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetDpetAll(this.keyword).then(response => {
        loading.hide();
        this.deptList = response.data;
      });
    }
  }
};
</script>
<style>
.searchbox {
  display: flex;
  flex-direction: row;
  padding: 0.2rem;
  box-sizing: border-box;
}
.officepage .search {
  position: relative;
  flex: 1;
}
.search .searchinput {
  height: 0.6rem;
  font-size: 0.22rem;
  font-family: "MicrosoftYaHei";
  border-radius: 0.3rem;
  padding-left: 0.6rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 0.01rem solid #dddddd;
  background-color: white;
}
.officepage .search .searchpic {
  width: 0.22rem;
  height: 0.22rem;
  position: absolute;
  left: 0.22rem;
  top: 50%;
  margin-top: -0.11rem;
}
.officepage .searchbtn {
  width: 1.2rem;
  height: 0.6rem;
  display: inline-block;
  background: #1592e4;
  color: white;
  line-height: 0.6rem;
  text-align: center;
  border-radius: 0.1rem;
}
.officepage {
  width: 100%;
  height: auto;
  background: rgba(255, 255, 255, 1);
}

.officepage .chooseCon {
  width: 100%;
  height: 0.8rem;

  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

  padding: 0 0.2rem;
  line-height: 0.8rem;
  box-sizing: border-box;
  margin-left: 0.18rem;
  border-bottom: 0.01rem solid #dddddd;
}

.officepage .chooseCon .condeteil {
  position: relative;
}

.officepage .grouppic {
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  background: rgba(21, 146, 228, 1);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0.1rem;
}

.officepage .jtpic {
  display: inline-block;
  width: 0.14rem;
  height: 0.26rem;
  position: absolute;
  right: 0.15rem;
  top: 50%;
  margin-top: -0.09rem;
}

.officepage .botpic {
  width: 100%;
  height: 0.9rem;
}

.officepage .botpic > img {
  width: 0.77rem;
  height: 0.64rem;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/section-office/section-office.vue